export const MAX_TAB_ITEMS = 50;
export const MAX_TAB_MEMBERS = 20;
export const MAX_TAB_NAME_LENGTH = 50;
export const MAX_ITEM_NAME_LENGTH = 50;
